<template>
  <div id="match">
    <template v-if="match">
      <div class="header">
        <div class="summary">
          <template v-if="team_1">
            <router-link :to="'/team/' + team_1.id" class="team">
              <cld-image
                class="logo"
                :publicId="team_1.shield"
                type="fetch"
                loading="lazy"
              >
                <cld-transformation
                  height="100"
                  radius="3"
                  crop="fill"
                  fetchFormat="auto"
                />
              </cld-image>
              <div class="name">{{ team_1.name }}</div>
            </router-link>
          </template>
          <template v-else>
            <div class="team">
              <cld-image
                class="logo"
                :publicId="match.local_team.shield"
                type="fetch"
                loading="lazy"
              >
                <cld-transformation
                  height="100"
                  radius="3"
                  crop="fill"
                  fetchFormat="auto"
                />
              </cld-image>
              <div class="name">{{ match.local_team.name }}</div>
            </div>
          </template>

          <div class="meta">
            <div class="competition" v-if="categories[match.category]">
              <span class="category">{{
                categories[match.category].name
              }}</span>
              <template v-if="match.group">
                <span class="group"
                  >{{ $t("miclive.competition.group") }}
                  {{
                    categories[match.category].groups[match.group].name
                  }}</span
                >
                <span class="round">{{
                  $t(
                    categories[match.category].groups[match.group].rounds[
                      match.round
                    ].name
                  )
                }}</span>
              </template>
              <template v-else-if="match.phase">
                <span class="group">
                  {{ $t(categories[match.category].phases[match.phase].name) }}
                </span>
                <span class="round">
                  {{
                    $t(
                      categories[match.category].phases[match.phase].rounds[
                        match.round
                      ].name
                    )
                  }}
                </span>
              </template>
              <span class="name">{{ match.name }}</span>
            </div>
            <div class="date">{{ formatDate(match.date) }}</div>

            <div class="score">
              <div class="value">
                {{ match.local_team_goals ? match.local_team_goals : "-" }}

                <span v-if="match.local_team_p_goals != null" class="penalties">
                  ({{ match.local_team_p_goals }})
                </span>
              </div>
              <div class="value">
                {{ match.away_team_goals ? match.away_team_goals : "-" }}
                <span v-if="match.away_team_p_goals != null" class="penalties">
                  ({{ match.away_team_p_goals }})
                </span>
              </div>
            </div>
            <div class="status">
              {{ $t("miclive.match.status" + match.status) }}
            </div>
          </div>

          <template v-if="team_2">
            <router-link :to="'/team/' + team_2.id" class="team">
              <cld-image
                class="logo"
                :publicId="team_2.shield"
                type="fetch"
                loading="lazy"
              >
                <cld-transformation
                  height="100"
                  radius="3"
                  crop="fill"
                  fetchFormat="auto"
                />
              </cld-image>
              <div class="name">{{ team_2.name }}</div>
            </router-link>
          </template>
          <template v-else>
            <div class="team">
              <cld-image
                class="logo"
                :publicId="match.away_team.shield"
                type="fetch"
                loading="lazy"
              >
                <cld-transformation
                  height="100"
                  radius="3"
                  crop="fill"
                  fetchFormat="auto"
                />
              </cld-image>
              <div class="name">{{ match.away_team.name }}</div>
            </div>
          </template>
        </div>
        <div class="actions">
          <template v-if="facilities[match.facility]">
            <router-link :to="'/facilities/' + match.facility" class="facility">
              {{ facilities[match.facility].name }}
            </router-link>
          </template>
          <template v-else
            ><div class="facility"></div
          ></template>
          <div class="refresh">
            <div v-if="isActive" class="button" @click="refresh()">
              {{ $t("miclive.live.refresh") }}
            </div>
          </div>
          <a
            v-if="match.streaming"
            target="_blank"
            :href="match.streaming"
            class="live"
            >{{ $t("miclive.match.view") }}</a
          >
        </div>
      </div>
      <div class="topbar">
        <div class="item" :class="{ selected: page == 1 }" @click="select(1)">
          {{ $t("miclive.match.summary") }}
        </div>
        <div class="item" :class="{ selected: page == 2 }" @click="select(2)">
          {{ $t("miclive.match.squad") }}
        </div>
        <div class="item" :class="{ selected: page == 3 }" @click="select(3)">
          {{ $t("miclive.match.stats") }}
        </div>
      </div>
      <div class="content">
        <template v-if="page == 1">
          <!-- {{ events }} -->
          <template v-if="Object.keys(events).length > 0">
            <div class="events">
              <div
                v-for="event in events"
                :key="event.id"
                class="item"
                :class="[event.data.team, event.type]"
              >
                <!-- <template v-if="event.type == 'penalties'">
                  <div class="new">
                    {{ $t("miclive.match.init_penalties") }}
                  </div>
                </template> -->

                <template
                  v-if="
                    ['penalties', 'start1', 'start2', 'stop1', 'end'].includes(
                      event.type
                    )
                  "
                >
                  <div class="new">
                    <span class="icon"></span>
                    {{ $t(event.data.description) }}
                  </div>
                </template>
                <template v-else>
                  <div v-if="!event.hide_time" class="time">
                    {{ event.data.time }}'
                  </div>
                  <div class="type"></div>
                  <div class="player">
                    {{
                      players[event.data.player_id]
                        ? players[event.data.player_id].name
                        : ""
                    }}
                    <b>
                      {{
                        players[event.data.player_id]
                          ? players[event.data.player_id].surname
                          : ""
                      }}
                    </b>
                  </div>
                </template>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="empty">{{ $t("miclive.match.nologs") }}</div>
          </template>
          <!-- {{ match.logs }} -->
        </template>
        <template v-else-if="page == 2">
          <div class="squad">
            <div v-if="team_1" class="half local">
              <Player
                v-for="item in team_1.players"
                :key="item.id"
                :item="item"
                :staff="false"
              ></Player>
              <Player
                v-for="item in team_1.staff"
                :key="item.id"
                :item="item"
                :staff="true"
              ></Player>
            </div>
            <div v-if="team_2" class="half away">
              <Player
                v-for="item in team_2.players"
                :key="item.id"
                :item="item"
                :staff="false"
                customClass="right"
              ></Player>
              <Player
                v-for="item in team_2.staff"
                :key="item.id"
                :item="item"
                :staff="true"
                customClass="right"
              ></Player>
            </div>
          </div>
        </template>
        <template v-else-if="page == 3">
          <div class="stats">
            <div
              v-for="(stat, index) in stats"
              :key="index"
              class="item"
              :class="{ show: parseInt(match.status) < 2 }"
            >
              <div class="meta">
                <div class="value">{{ stat.home }}</div>
                <div class="name">
                  {{ $t("miclive.competition." + index) }}
                </div>
                <div class="value">{{ stat.away }}</div>
              </div>
              <div class="bar">
                <div
                  class="progress home"
                  :style="{
                    width:
                      stat.total > 0
                        ? (stat.home / stat.total) * 100 + '%'
                        : '50%'
                  }"
                ></div>
                <div
                  class="progress away"
                  :style="{
                    width:
                      stat.total > 0
                        ? (stat.away / stat.total) * 100 + '%'
                        : '50%'
                  }"
                ></div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </template>
    <template v-else>
      <div class="loader"></div>
    </template>
  </div>
</template>

<script>
import { Api } from "@/core/api.js";

import Player from "@/components/domain/competition/player";
const api = new Api();

const TIMEOUT = 30 * 1000;

export default {
  name: "Match",
  components: { Player },
  data() {
    return {
      match: false,
      team_1: false,
      team_2: false,
      page: 1,
      timer: false,
      eventTypes: [
        "goal",
        "redcard",
        "yellowcard",
        "autogoal",
        "penalty",
        "penaltyfail",
        "penalties",
        "stop1",
        "start1",
        "start2",
        "end"
      ],
      players: {}
    };
  },
  computed: {
    facilities() {
      return this.$store.getters["facilities/getList"]();
    },
    categories() {
      return this.$store.getters["competition/getCategories"]();
    },
    events() {
      var results = [];
      var penalties = false;
      var yellowHash = [];
      for (var i in this.match.logs) {
        var event = this.match.logs[i];
        if (this.eventTypes.includes(event.type)) {
          event.data = JSON.parse(event.data);
          if (event.type == "penalties") {
            penalties = true;
          }
          if (penalties) {
            event.hide_time = true;
          }

          if (event.type == "yellowcard") {
            if (yellowHash.includes(event.data.player_id)) {
              event.type = "yellowcard2";
            } else {
              yellowHash.push(event.data.player_id);
            }
          }
          results.push(event);
        }
      }

      return results;
    },
    stats() {
      var results = {
        goal: { home: 0, away: 0, total: 0 },
        redcard: { home: 0, away: 0, total: 0 },
        yellowcard: { home: 0, away: 0, total: 0 },
        autogoal: { home: 0, away: 0, total: 0 },
        offside: { home: 0, away: 0, total: 0 },
        corner: { home: 0, away: 0, total: 0 },
        changein: { home: 0, away: 0, total: 0 }
      };

      var discard_penalties = false;
      for (var i in this.match.logs) {
        var event = this.match.logs[i];
        var type = event.type;
        if (event.type == "autogoal" || event.type == "penalty") {
          type = "goal";
        }

        if (event.type == "penalties") {
          discard_penalties = true;
        }

        if (Object.keys(results).includes(type)) {
          //   console.log(type + "  " + event.type + " " + discard_penalties);
          if (!(event.type == "penalty" && discard_penalties)) {
            if (typeof event.data === "string") {
              event.data = JSON.parse(event.data);
            }

            results[type][event.data.team]++;
            results[type].total++;
          }
        }
      }

      return results;
    },
    isActive() {
      return parseInt(this.match.status) > 2 && parseInt(this.match.status) < 7;
    }
  },
  methods: {
    load(init) {
      var self = this;
      if (this.$route.params.id) {
        this.matches = false;
        api
          .post("miclive/matches/" + this.$route.params.id, {})
          .then(function(data) {
            self.match = data.data;

            var team1_numbers = [];
            var team2_numbers = [];
            var team1_match_players = {};
            var team2_match_players = {};

            for (var i in data.data.logs) {
              if (data.data.logs[i].type == "ready") {
                var event_data = JSON.parse(data.data.logs[i].data);
                if (event_data) {
                  team1_numbers =
                    event_data.prefilled[self.match.local_team.id].numbers;
                  team2_numbers =
                    event_data.prefilled[self.match.away_team.id].numbers;
                }
                break;
              }
            }

            if (init) {
              var team1Id = self.match.local_team.id;
              var team2Id = self.match.away_team.id;
              if (team1Id) {
                api.post("miclive/team/" + team1Id, {}).then(function(data) {
                  if (data.data) {
                    self.team_1 = data.data;

                    for (var i in self.team_1.players) {
                      var player = self.team_1.players[i];
                      if (
                        Object.keys(team1_numbers).includes(player.player_id)
                      ) {
                        player.number = team1_numbers[player.player_id];
                        self.team_1[i] = player;
                      }
                    }

                    for (var i in data.data.players) {
                      var player = data.data.players[i];
                      self.players[player.player_id] = player;
                    }
                    for (var i in data.data.staff) {
                      var staff = data.data.staff[i];
                      self.players[staff.id] = staff;
                    }

                    self.team_1.players = self.sortPlayers(
                      Object.values(self.team_1.players)
                    );
                  }
                });
              }
              if (team2Id) {
                api.post("miclive/team/" + team2Id, {}).then(function(data) {
                  if (data.data) {
                    self.team_2 = data.data;

                    for (var i in self.team_2.players) {
                      var player = self.team_2.players[i];
                      if (
                        Object.keys(team2_numbers).includes(player.player_id)
                      ) {
                        player.number = team2_numbers[player.player_id];
                        self.team_2[i] = player;
                      }
                    }

                    for (var i in data.data.players) {
                      var player = data.data.players[i];
                      self.players[player.player_id] = player;
                    }
                    for (var i in data.data.staff) {
                      var staff = data.data.staff[i];
                      self.players[staff.id] = staff;
                    }
                    self.team_2.players = self.sortPlayers(
                      Object.values(self.team_2.players)
                    );
                  }
                });
              }
            }
          });
      }
    },
    formatDate(date) {
      return moment(date, "YYYY-MM-DD HH:mm").format("ddd DD/MM HH:mm");
    },
    sortPlayers(players) {
      return players.sort((a, b) =>
        parseInt(a.number) > parseInt(b.number)
          ? 1
          : parseInt(b.number) > parseInt(a.number)
          ? -1
          : 0
      );
    },
    select(page) {
      this.page = page;
    },
    refresh() {
      var self = this;
      if (!this.timer) {
        self.load(false);
        this.timer = setTimeout(() => {
          clearTimeout(self.timer);
          self.timer = null;
        }, TIMEOUT);
      }
    },
    getPlayer(team, playerId) {
      if (team == "home") {
        return this.team_1.players && this.team_1.players[playerId]
          ? this.team_1.players[playerId].name
          : "";
      }
      return this.team_2.players && this.team_2.players[playerId]
        ? this.team_2.players[playerId].name
        : "";
    }
  },
  created() {
    this.load(true);
  }
};
</script>

<style lang="scss" scoped>
#match {
  .header {
    background-color: #fff;
    border-radius: 4px;
    padding: 15px 5px;
    width: 100%;
    margin-bottom: 10px;
    align-items: center;
    text-decoration: none;
    color: #222;
    position: fixed;
    top: 60px;
    left: 0;
    height: 200px;
    text-align: center;
    z-index: 10;

    .summary {
      max-width: 800px;
      margin: 0 auto;
      display: flex;
      .team {
        width: 30%;
        text-align: center;
        text-decoration: none;
        .logo {
          width: 80%;
          max-width: 70px;
        }
        .name {
          font-family: $font-title;
          color: #222;
          font-size: 12px;
          margin-top: 5px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }
      .meta {
        text-transform: uppercase;
        width: 40%;
        font-size: 10px;
        text-align: center;

        .competition {
          color: $main-color;
          .category {
            font-family: $font-title;
            &:after {
              content: "|";
              font-family: $font-text;
              margin: 0 2px;
            }
          }
          .group {
            font-family: $font-title;
            &:after {
              content: "|";
              font-family: $font-text;
              margin: 0 2px;
            }
          }
          .round {
            font-family: $font-title;
            &:after {
              content: "|";
              font-family: $font-text;
              margin: 0 2px;
            }
          }
          .name {
          }
        }
        .date {
          font-family: $font-title;
          color: #222;
          font-size: 12px;
        }
        .facility {
          text-overflow: ellipsis;
          overflow: hidden;
          width: 100%;
          white-space: nowrap;
          text-decoration: none;
        }
        .status {
          margin-top: 10px;
          font-size: 9px;
        }
        .score {
          border-radius: 4px;
          background-color: #eee;
          display: flex;
          text-align: center;
          padding: 5px;
          width: 70%;
          margin: 4px auto;

          .value {
            width: 100%;
            font-family: $font-title;
            font-size: 24px;

            .penalties {
              font-size: 16px;
              display: inherit;
            }
          }
        }
      }
    }

    .actions {
      max-width: 800px;
      margin: 0 auto;
      display: flex;
      font-size: 10px;
      margin-top: 25px;
      align-items: center;

      .facility {
        width: 35%;
        background: url("~@/../public/img/marker.svg") no-repeat center left 5px;
        background-size: 20px;
        padding: 10px 0;
        padding-left: 30px;
        text-decoration: none;
        color: #222;
        text-align: left;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        cursor: pointer;
      }
      .refresh {
        width: 30%;
        padding: 0 10px;
        .button {
          margin: 0 auto;
          width: 100%;
          max-width: 120px;
          background: url("~@/../public/img/refresh.svg") no-repeat center left
            10px #fff;
          background-size: 15px;
          padding: 10px;
          padding-left: 35px;
          color: #222;
          border: 1px solid #ddd;
          cursor: pointer;
        }
      }
      .live {
        width: 35%;
        background: url("~@/../public/img/streaming.png") no-repeat center left
          10px #fff;
        background-size: 40px;
        padding: 10px 10px;
        padding-left: 60px;
        text-transform: uppercase;
        text-align: left;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        cursor: pointer;
      }
    }
  }
  .topbar {
    background-color: #fff;
    padding: 15px;
    width: 100%;
    margin-bottom: 10px;
    display: flex;
    box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.1);
    align-items: center;
    text-decoration: none;
    color: #222;
    position: fixed;
    top: 260px;
    left: 0;
    height: 45px;
    background-color: $secondary-color;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    text-align: center;
    z-index: 10;

    .item {
      text-transform: uppercase;
      font-size: 12px;
      padding: 0 5px;
      text-decoration: none;
      color: #222;
      text-align: center;
      max-width: 200px;
      margin: 0 auto;
      cursor: pointer;

      &.selected {
        font-family: $font-title;
      }
    }
  }

  .content {
    padding-top: 250px;
    max-width: 800px;
    margin: 0 auto;
    padding-bottom: 40px;

    .squad {
      padding: 0px;
      width: 100%;
      overflow: hidden;

      .half {
        width: 49%;
        float: left;
        margin-bottom: 10px;
        overflow: hidden;

        &.away {
          float: right;
          text-align: right;
        }
      }
    }

    .empty {
      background: url("~@/../public/img/rest.svg") no-repeat top 10px center;
      background-size: 70px;
      width: 100%;
      height: 120px;
      padding-top: 100px;
      text-align: center;
      font-size: 12px;
    }

    .events {
      background: #fff;
      border-radius: 4px;
      padding: 5px;
      display: flex;
      flex-direction: column-reverse;

      .item {
        padding: 15px 10px;
        border-bottom: 1px solid #ccc;
        display: flex;
        font-size: 13px;
        align-items: center;
        .new {
          text-align: center;
          width: 100%;
          text-transform: uppercase;
          line-height: 20px;
          background-color: #eee;
          padding: 15px 0;
          border-radius: 4px;

          .icon {
            width: 20px;
            height: 20px;
            background-image: url("/img/events/event.svg");
            background-repeat: no-repeat;
            background-size: 20px;
            background-position: center;
            display: inline-block;
            margin-bottom: -5px;
            margin-right: 10px;
          }
        }
        .time {
          font-family: $font-title;
          width: 30px;
        }
        .type {
          width: 30px;
          height: 30px;
          background-image: url("/img/events/goal.svg");
          background-repeat: no-repeat;
          background-size: 20px;
          background-position: center;
        }
        .player {
          width: calc(70% - 60px);
          white-space: nowrap;
          text-overflow: ellipsis;
          display: contents;

          b {
            margin: 0 3px;
            font-family: $font-title;
          }
        }

        &.away {
          flex-direction: row-reverse;
          .time {
            text-align: right;
          }
        }

        &.yellowcard {
          .type {
            background-image: url("/img/events/yellow.svg");
          }
        }
        &.yellowcard2 {
          .type {
            background-image: url("/img/events/yellowred.svg");
          }
        }
        &.redcard {
          .type {
            background-image: url("/img/events/red.svg");
          }
        }
        &.autogoal {
          .type {
            background-image: url("/img/events/autogoal.svg");
          }
          .player {
            &:after {
              content: " (PP)";
            }
          }
        }
        &.penalty {
          .type {
            background-image: url("/img/events/goal.svg");
          }
          .player {
            &:after {
              content: " (P)";
            }
          }
        }

        &.penaltyfail {
          .type {
            background-image: url("/img/events/penalty_fail.svg");
          }
          .player {
            &:after {
              content: " (P)";
            }
          }
        }
      }
    }

    .stats {
      background: #fff;
      border-radius: 4px;
      padding: 5px;

      .item {
        text-align: center;
        padding: 10px 5px;
        margin-bottom: 15px;
        .meta {
          margin-bottom: 5px;
          .value {
            display: inline-block;
            width: 40px;
            font-family: $font-title;
          }
          .name {
            display: inline-block;
            width: calc(100% - 80px);
            font-size: 14px;
          }
        }
        .bar {
          background: #ccc;
          border-radius: 10px;
          width: 100%;
          height: 10px;
          overflow: hidden;

          .progress {
            height: 10px;
            display: inline-block;
            position: relative;
            float: left;

            &.home {
              background-color: $main-color;
            }
            &.away {
              background-color: #ff5722;
            }
          }
        }

        &.show {
          .number {
            display: none;
          }
          .progress {
            display: none;
          }
        }
      }
    }
  }
}
</style>
